import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import LoadingSpinner from './LoadingSpinner'

export default function SuperAdminRoute({ children }) {
  const [loading, setLoading] = useState(true)
  const [isSuperAdmin, setIsSuperAdmin] = useState(false)

  useEffect(() => {
    checkSuperAdmin()
  }, [])

  async function checkSuperAdmin() {
    try {
      const { data: { user } } = await supabase.auth.getUser()

      if (!user) {
        setIsSuperAdmin(false)
        setLoading(false)
        return
      }

      // Check if user is super admin
      const { data: userData } = await supabase
        .from('users')
        .select('is_super_admin')
        .eq('id', user.id)
        .single()

      setIsSuperAdmin(userData?.is_super_admin === true)
    } catch (error) {
      console.error('Super admin check error:', error)
      setIsSuperAdmin(false)
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <LoadingSpinner message="Verifying access..." />
  }

  if (!isSuperAdmin) {
    return <Navigate to="/login" replace />
  }

  return children
}